const dateFormat = /^(0[1-9]|10|11|12)\/(0[1-9]|[1-2][0-9]|3[0-1])\/(19|[2-9]\d)\d{2}$/;

export const formatDate = (value, options) => {
    options = options || { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(value);
    if (date) {
        return date.toLocaleDateString([],options);
    }
    else {
        return value;
    }
};

export const formatTime = (value, options) => {
    let timeOptions = options || { hour: '2-digit', minute: '2-digit' };
    const date = new Date(value);
    if (date) {
        return date.toLocaleTimeString([], timeOptions);
    }
    else {
        return value;
    }
};

export const isValidDate = (value) => {
    let noMonthShift = true;
    let dateValue = null;
    if (value instanceof Date) {
        dateValue = value;
    }
    else {
        if (!value || !dateFormat.test(value)) {
            return false;
        }
        dateValue = new Date(value);
        noMonthShift = Number(value.substr(0, 2)) === dateValue.getMonth() + 1;
    }
    return noMonthShift;
};

export const removeTime = (date) => {
    if (isValidDate(date)) {
        date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    return date;
};

export const getAge = date => {
    var ageDifMs = Date.now() - new Date(date).getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
};